import { Select } from "antd";
import React from "react";
const { Option } = Select;

const CustomDropdown = ({ data = [], onSelect, status = "" }) => {
  return (
    <Select
      placeholder="Filter By"
      style={{ width: "100%" }}
      onChange={(e) => onSelect(e)}
      // allowClear
      value={status}
    >
      {data.map((el, index) => {
        return (
          <Option value={el.value} key={index}>
            {el.title}
          </Option>
        );
      })}
    </Select>
  );
};

export default CustomDropdown;
